export const footer = {
    "how_it_works": "Cómo funciona",
    "why_worth_it": "Por qué vale la pena",
    "q_and_a": "Preguntas y respuestas",
    "policy": "Políticas",
    "accessibility": "Accesibilidad",
    "support": "Asistencia técnica",
    "all_rights": "© {{currentYear}} todos los derechos reservados",
    "privacy": "Privacidad",
    "languagePlaceholder": "Selecione idioma",
    "languages": {
        "en": "English",
        "he": "עברית",
        "es": "Español"
    }
};
